
import React from 'react';

import { TabPanel } from '../../core';
import SearchPanel from './SearchPanel';

const renderTabPanel = (props) => {
    return (
        <TabPanel key={props.name} name={props.name} iconName={props.iconName} title={props.title}>
            <SearchPanel
                appActions={props.appActions}
                onObjectInfo={props.onObjectInfo}
            />
        </TabPanel>
    );
}

export default renderTabPanel;
